import { render, staticRenderFns } from "./red-packet-open.mpx?vue&type=template&id=78c702e2&scoped=true&isComponent&outputPath=components%2Fred-packet-open32126ff4%2Findex"
import script from "./red-packet-open.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fred-packet-open32126ff4%2Findex"
export * from "./red-packet-open.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fred-packet-open32126ff4%2Findex"
import style0 from "./red-packet-open.mpx?vue&type=style&index=0&id=78c702e2&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m32126ff4%22%7D&isComponent&outputPath=components%2Fred-packet-open32126ff4%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c702e2",
  null
  
)

export default component.exports